/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PaymentWithoutBilling {
  amount?: number;
  creditCardId?: number;
  dateAuthorized?: Date;
  discount?: number;
  editionId?: string;
  installments?: number;
  shippingPrice?: number;
  subscriberId?: number;
  tid?: number;
}
